import { render } from "./NavBarCategoryLabel.vue?vue&type=template&id=54f2d4c9&scoped=true"
import script from "./NavBarCategoryLabel.vue?vue&type=script&lang=js"
export * from "./NavBarCategoryLabel.vue?vue&type=script&lang=js"

import "./NavBarCategoryLabel.vue?vue&type=style&index=0&id=54f2d4c9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f2d4c9"]])

export default __exports__